module.exports = __webpack_public_path__ + "785442e19580ce66ea98cc5040f739c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-stripes-purple.png
// module id = 1998
// module chunks = 0